<template>
  <div
    id="panorama"
    @click="onClick"
    @mouseup="onMouseUp"
    @touchmove="onTouchMove"
    @touchend="onTouchEnd">

    <div id="overlays">
      <div v-for="spot in longtextInfoHotSpots"
        :key="spot.key"
        class="overlayContainer"
        :class="{active: (spot.isActive)}">
        <div class="closeBGR" @click="closeHotSpot(spot)">schließen</div>
        <div class="closeButton" @click="closeHotSpot(spot)">schließen</div>
        <div class="overlay">
          <h3 class="h2" v-html="spot.text"></h3>
          <div class="longtext" v-html="spot.longtext"></div>
        </div>
      </div>
    </div>

    <!-- <div class="controls">
      <label>
        <span>Hfov:</span>
        <input type="text" v-model.number="hfov" style="width: 50px;">
      </label>
      <label>
        <span>Yaw:</span>
        <input type="text" v-model.number="yaw" style="width: 50px;">
      </label>
      <label>
        <span>Pitch:</span>
        <input type="text" v-model.number="pitch" style="width: 50px;">
      </label>
      <label>
        <input type="checkbox" v-model="isAutoRotationOn">
        <span>Auto Rotation</span>
      </label>
      <label>
        <input type="checkbox" v-model="isOrientationOn">
        <span>Orientation</span>
      </label>
    </div> -->

  </div>

</template>

<script>
import 'pannellum'
// import 'pannellum/build/pannellum.css'

import _debounce from 'lodash.debounce'

export default {
  name: 'Panorama',
  props: {
    scenes: {type: Object, default: () => {} },
  },
  data () {
    return {
      viewer: null,
      info: 'Scene switcher',
      rafId: -1,
      sceneId: this.$route.params.id,
      // currentScene: {},
      // pano control stuff ...
      // show: true,
      minHfov: 20,
      maxHfov: 90,
      showControls: true,
      showZoom: true,
      showFullscreen: true,
      // isAutoRotationOn: false,
      // isOrientationOn: false,
      hfov: 0,
      yaw: 0,
      pitch: 0,
    }
  },
  watch: {
    // https://router.vuejs.org/guide/essentials/dynamic-matching.html#reacting-to-params-changes
    $route(to) { // arguments possible: (to, from)
      // react to route changes...
      this.sceneId = to.params.id;
      if (this.sceneExisting) {
        this.setMetaTags();
        this.closeAllHotSpots();
        // console.log("route to " + to.params.id);
        if (this.viewer && this.viewer.getScene() != to.params.id) {
          // console.log("load scene ..." + to.params.id);
          this.viewer.loadScene(to.params.id);
        } else {
          // console.log("loadScene didn´t work 4sr");
        }
      } else {
        this.$router.push('/error');
      }
    },
    // control watcher ...
    // hfov (val) {
    //   if (this.viewer) this.viewer.setHfov(val, false)
    // },
    // yaw (val) {
    //   if (this.viewer) this.viewer.setYaw(val, false)
    // },
    // pitch (val) {
    //   if (this.viewer) this.viewer.setPitch(val, false)
    // },
    maxHfov () {
      if (this.viewer) {
        this.viewer.setHfovBounds([this.minHfov, this.maxHfov])
      }
    },
    minHfov () {
      if (this.viewer) {
        this.viewer.setHfovBounds([this.minHfov, this.maxHfov])
      }
    },
    isAutoRotationOn (val) {
      if (val) {
        this.viewer.startAutoRotate()
      } else {
        this.viewer.stopAutoRotate()
        if (this.panoControl.isOrientationOn) this.viewer.startOrientation()
      }
    },
    isOrientationOn (val) {
      if (val) {
        this.viewer.startOrientation()
      } else {
        this.viewer.stopOrientation()
        if (this.panoControl.isAutoRotationOn) this.viewer.startAutoRotate()
      }
    }
  },
  created() {
    console.log("created");
  },
  mounted () {
    console.log("created");
    this.rafId = window.requestAnimationFrame(this.loop);
    if (this.sceneExisting) {
      this.setMetaTags();
      this.load();
      this.closeAllHotSpots();
    } else {
      this.$router.push('/error');
    }
  },
  beforeDestroy() {
    // console.log("created");
    this.closeAllHotSpots();
    this.viewer.destroy();
    window.cancelAnimationFrame(this.rafId);
  },
  computed: {
    sceneExisting() {
      return (this.sceneId in this.scenes);
    },
    longtextInfoHotSpots() {
      let ret = [];
      if (this.scenes[this.sceneId].hotSpots) {
        ret = this.scenes[this.sceneId].hotSpots.filter(function(h) {
          return (h.type == "info" && h.longtext && h.longtext.length);
        });
      }
      return ret;
    }
  },
  methods: {
    load () {
      if (!this.viewer) {
        // manipuliere HotSpots in scenes ...
        for (let sceneId in this.scenes) {
          // definiere eigenes hotspot handling ...
          if (this.scenes[sceneId].hotSpots && this.scenes[sceneId].hotSpots.length) {
            for (let h in this.scenes[sceneId].hotSpots) {
              // console.log(this.scenes[sceneId].hotSpots[h]);
              this.scenes[sceneId].hotSpots[h].key = h;
              // checken ob hotSpot ein Typ "info" mit "longtext" ist ...""
              if (this.scenes[sceneId].hotSpots[h].type == "info"
              && this.scenes[sceneId].hotSpots[h].longtext
              && this.scenes[sceneId].hotSpots[h].longtext.length) {
                this.scenes[sceneId].hotSpots[h].isActive = false;
                // this.scenes[sceneId].hotSpots[h].isClosing = false;
                // this.scenes[sceneId].hotSpots[h].createTooltipFunc = this.createHotSpot;
                // if (!this.scenes[sceneId].hotSpots[h].createTooltipArgs) {
                //   this.scenes[sceneId].hotSpots[h].createTooltipArgs = this.scenes[sceneId].hotSpots[h].text;
                // }
                this.scenes[sceneId].hotSpots[h].clickHandlerFunc = this.openHotSpot;
                this.scenes[sceneId].hotSpots[h].clickHandlerArgs = this.scenes[sceneId].hotSpots[h];
              } //else if (this.scenes[sceneId].hotSpots[h].type == "scene") {
                // brauchen wir nicht, klären wir über eventHandler "scenechange" ...
              //}
              // console.log(h,this.scenes[sceneId].hotSpots[h]);
            }
          }
        }
        // this.$forceUpdate();
        // pano options ...
        let panoOptions = {
          autoLoad: true,
          // autoRotate: (this.autoRotate === true) ? -2 : 0,
          // orientationOnByDefault: this.orientation,
          sceneFadeDuration: 1000,
          compass: true,
          minHfov: this.minHfov,
          multiResMinHfov: true,
          maxHfov: this.maxHfov,
          // haov: 149.87,
          // vaov: 54.15,
          // scenes: this.scenes,
          // default: {
          //   firstScene: this.firstScene,
          // },
          scenes: this.scenes,
          // scenes: prepScenes,
          strings: {
            // bylineLabel: "von %s",
            bylineLabel: "%s",
          },
          default: {
            firstScene: this.sceneId,
          },
          // draggable: false,
          showZoomCtrl: this.showZoom,
          showFullscreenCtrl: this.showFullscreen,
          showControls: this.showControls,
        };

        Object.assign(panoOptions);
        this.viewer = window.pannellum.viewer("panorama", panoOptions);
        this.viewer.on('load', () => {
          // wenn ein Panorama geladen wurde ...
          this.$emit('load');
          // this.setAdditionalSceneOptions();
        });
        // this.viewer.off("scenechange");
        this.viewer.on("scenechange", (sceneId) => {
          // Szenenwechsel ...
          this.$router.push('/scene/'+sceneId);
        });
        this.viewer.on('error', (err) => {
          this.$emit('error', err);
        });
        // console.log(this.viewer);
        this.$forceUpdate();
      }
    },
    openHotSpot(ev,h) {
      // console.log("openHotSpot()",ev,h);
      h.isActive = true;
      this.$forceUpdate();
    },
    closeHotSpot(h) {
      // console.log("closeHotSpot",h);
      h.isActive = false;
      this.$forceUpdate();
    },
    closeAllHotSpots() {
      for (let sceneId in this.scenes) {
        if (this.scenes[sceneId].hotSpots && this.scenes[sceneId].hotSpots.length) {
          for (let h in this.scenes[sceneId].hotSpots) {
            if (this.scenes[sceneId].hotSpots[h].isActive) this.scenes[sceneId].hotSpots[h].isActive = false;
          }
        }
      }
    },
    // removeHotSpots: function() {
    //   const boxContainer = document.getElementById("overlays");
    //   boxContainer.classList.remove("active");
    //   // boxContainer.innerHTML = "";
    //   while (boxContainer.firstChild) {
    //     boxContainer.removeChild(boxContainer.lastChild);
    //   }
    // },
    setMetaTags () {
      let title = (this.scenes[this.sceneId].title)
        ? this.scenes[this.sceneId].title + " | "
        : "";
      document.title = title + "Schabbell 360";
    },
    loop () {
      this.rafId = window.requestAnimationFrame(this.loop)
      let hfov = this.viewer.getHfov()
      // let yaw = this.viewer.getYaw()
      // let pitch = this.viewer.getPitch()
      // if (pitch > 90) pitch = 90
      // else if (pitch < -90) pitch = -90
      if (hfov != this.hfov) this.hfov = hfov;
      // if (yaw != this.yaw) this.yaw = yaw;
      // if (pitch != this.pitch) this.pitch = pitch;
    },
    onMouseUp () {
      if (this.debug) this.info += ' mu'
      this.debounceRotate()
    },
    onTouchMove () {
      if (this.debug) this.info += ' tm'
    },
    onTouchEnd () {
      if (this.debug) this.info += ' te'
      this.debounceRotate()
    },
    // onClick(ev) {
    onClick() {
      // get clicked coordinates in panorama ...
      // let coords = [];
      // if (this.viewer) {
      //   coords = this.viewer.mouseEventToCoords(ev);
      //   this.pitch = coords[0];
      //   this.yaw = coords[1];
      // }
      // console.log("mouse clicked!", coords);
    },
    debounceRotate: _debounce(function () {
      // priority of orientation is higher
      if (this.orientation) this.viewer.startOrientation()
      else if (this.autoRotate) this.viewer.startAutoRotate()
    }, 3000),
  }
}
</script>
